import { render, staticRenderFns } from "./Component.vue?vue&type=template&id=45319ea2&scoped=true"
import script from "./Component.vue?vue&type=script&setup=true&lang=ts"
export * from "./Component.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Component.vue?vue&type=style&index=0&id=45319ea2&prod&scoped=true&lang=less"
import style1 from "./Component.vue?vue&type=style&index=1&id=45319ea2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45319ea2",
  null
  
)

export default component.exports